import { FETCH_ERROR, FETCH_START, FETCH_SUCCESS, UPDATE_PERCENT_DOWNLOAD, UPDATE_STATUS_DOWNLOAD } from '../../@jumbo/constants/ActionTypes';

const INIT_STATE = {
  initialURL: '/',
  error: '',
  message: '',
  loading: false,
  download: false,
  percent: 0
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case FETCH_START: {
      return { ...state, error: '', message: '', loading: true };
    }
    case FETCH_SUCCESS: {
      return { ...state, error: '', loading: false, message: action.payload };
    }
    case FETCH_ERROR: {
      return { ...state, loading: false, message: '', error: action.payload };
    }
    case UPDATE_PERCENT_DOWNLOAD : {
      return { ...state, percent : action.payload }
    }
    case UPDATE_STATUS_DOWNLOAD : {
      return { ...state, download : true }
    }
    default:
      return state;
  }
};
